export default function LoadingIcon() {
  return (
    <div className="flex items-center justify-center p-4">
      <div className="w-5 h-5 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
